// extracted by mini-css-extract-plugin
export default {"navContainer":"ManagerHeader_navContainer__8mue7","nav":"ManagerHeader_nav__YYEzc"};